:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._sectionControls_1bk2x_7 {
  position: absolute;
  left: 0;
  width: 100%;
  pointer-events: none; }
  ._sectionControls_1bk2x_7 > ._highlight_1bk2x_12 {
    display: none;
    height: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    border: 3px solid #116dff;
    align-items: center;
    justify-content: flex-end;
    background-color: rgba(94, 255, 255, 0.2);
    pointer-events: auto;
    cursor: move; }
    ._sectionControls_1bk2x_7 > ._highlight_1bk2x_12._withShadow_1bk2x_23 {
      box-shadow: 0 0 30px 3px rgba(0, 0, 0, 0.2); }
    ._sectionControls_1bk2x_7 > ._highlight_1bk2x_12 > ._dragHandle_1bk2x_25 {
      max-height: 36px;
      width: 18px;
      margin-right: -21px;
      background-color: #116dff;
      border-radius: 0 18px 18px 0;
      cursor: move;
      display: flex;
      align-items: center;
      justify-content: center; }
      ._sectionControls_1bk2x_7 > ._highlight_1bk2x_12 > ._dragHandle_1bk2x_25 > ._dragHandleDots_1bk2x_35 {
        margin-left: -5px; }
  ._sectionControls_1bk2x_7._showHighlight_1bk2x_37 > ._highlight_1bk2x_12 {
    display: flex; }
  ._sectionControls_1bk2x_7._noDragHandle_1bk2x_39 > ._highlight_1bk2x_12 > ._dragHandle_1bk2x_25 {
    display: none; }
  ._sectionControls_1bk2x_7._headerFooterBlocker_1bk2x_41 > ._highlight_1bk2x_12 {
    display: flex;
    border: none;
    background-color: transparent;
    cursor: default; }
  ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 {
    position: absolute;
    top: 0;
    max-height: 74px;
    width: 168px; }
    ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 > ._sectionButtons_1bk2x_46 {
      position: absolute;
      top: 50%;
      margin-top: -18px; }
      ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 > ._sectionButtons_1bk2x_46 ._headerFooterInfo_1bk2x_55 {
        height: 36px;
        pointer-events: auto;
        display: flex;
        align-items: center; }
        ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 > ._sectionButtons_1bk2x_46 ._headerFooterInfo_1bk2x_55 > ._infoIcon_1bk2x_60 circle {
          fill: transparent; }
        ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 > ._sectionButtons_1bk2x_46 ._headerFooterInfo_1bk2x_55 > ._infoIcon_1bk2x_60 path {
          fill: #868aa5; }
        ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 > ._sectionButtons_1bk2x_46 ._headerFooterInfo_1bk2x_55 > ._infoText_1bk2x_64 {
          padding-left: 10px;
          color: #868aa5; }
        ._sectionControls_1bk2x_7 > ._sectionButtonsWrapper_1bk2x_46 > ._sectionButtons_1bk2x_46 ._headerFooterInfo_1bk2x_55:hover > ._infoIcon_1bk2x_60 path {
          fill: #116dff; }
